// PromptGenerator/config/quickModeQuestions.ts
import { Question } from '../types';

export const quickModeQuestions: Question[] = [
  {
    id: 'outputType',
    titleKey: 'promptGenerator.quickQuestions.outputType.title',
    type: 'single',
    required: true,
    options: [
      { id: 'image', labelKey: 'promptGenerator.quickQuestions.outputType.options.image', icon: 'faImage', value: 'image' },
      { id: 'video', labelKey: 'promptGenerator.quickQuestions.outputType.options.video', icon: 'faVideo', value: 'video' },
      { id: 'music', labelKey: 'promptGenerator.quickQuestions.outputType.options.music', icon: 'faMusic', value: 'music' },
      { id: 'sfx', labelKey: 'promptGenerator.quickQuestions.outputType.options.sfx', icon: 'faMicrophone', value: 'sfx' },
      { id: 'narration', labelKey: 'promptGenerator.quickQuestions.outputType.options.narration', icon: 'faMicrophone', value: 'narration' },
      { id: 'others', labelKey: 'promptGenerator.quickQuestions.outputType.options.others', icon: 'faEllipsisH', value: 'others' },
    ]
  },
  {
    id: 'contentStyle',
    titleKey: 'promptGenerator.quickQuestions.contentStyle.title',
    type: 'single',
    required: true,
    options: [
      { id: 'cinematic', labelKey: 'promptGenerator.quickQuestions.contentStyle.options.cinematic', value: 'cinematic' },
      { id: 'realistic', labelKey: 'promptGenerator.quickQuestions.contentStyle.options.realistic', value: 'realistic' },
      { id: 'animated', labelKey: 'promptGenerator.quickQuestions.contentStyle.options.animated', value: '3D Pixar' },
      { id: 'artistic', labelKey: 'promptGenerator.quickQuestions.contentStyle.options.artistic', value: 'artistic' },
      { id: 'professional', labelKey: 'promptGenerator.quickQuestions.contentStyle.options.professional', value: 'professional' },
      { id: 'inspirational', labelKey: 'promptGenerator.quickQuestions.contentStyle.options.inspirational', value: 'inspirational' }
    ]
  },
  {
    id: 'targetUse',
    titleKey: 'promptGenerator.quickQuestions.targetUse.title',
    type: 'single',
    required: true,
    options: [
      { id: 'social-media', labelKey: 'promptGenerator.quickQuestions.targetUse.options.socialMedia', value: 'social media' },
      { id: 'marketing', labelKey: 'promptGenerator.quickQuestions.targetUse.options.marketing', value: 'marketing' },
      { id: 'storytelling', labelKey: 'promptGenerator.quickQuestions.targetUse.options.storytelling', value: 'storytelling' },
      { id: 'education', labelKey: 'promptGenerator.quickQuestions.targetUse.options.education', value: 'education' },
      { id: 'entertainment', labelKey: 'promptGenerator.quickQuestions.targetUse.options.entertainment', value: 'entertainment' },
      { id: 'religious', labelKey: 'promptGenerator.quickQuestions.targetUse.options.religious', value: 'religious' }
    ]
  }
];